import * as React from "react";

const ReadHttp = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M0 0h64v64H0z" fillOpacity={0} />
      <path d="M16 16h32v32H16z" />
      <path
        d="M31.987 18.667c-7.36 0-13.32 5.973-13.32 13.333s5.96 13.333 13.32 13.333c7.373 0 13.346-5.973 13.346-13.333S39.36 18.667 31.987 18.667zm9.24 8h-3.934a20.865 20.865 0 0 0-1.84-4.747 10.706 10.706 0 0 1 5.774 4.747zM32 21.387a18.782 18.782 0 0 1 2.547 5.28h-5.094A18.782 18.782 0 0 1 32 21.387zm-10.32 13.28A10.99 10.99 0 0 1 21.333 32c0-.92.134-1.813.347-2.667h4.507A22.02 22.02 0 0 0 26 32c0 .907.08 1.787.187 2.667H21.68zm1.093 2.666h3.934a20.865 20.865 0 0 0 1.84 4.747 10.65 10.65 0 0 1-5.774-4.747zm3.934-10.666h-3.934a10.65 10.65 0 0 1 5.774-4.747c-.8 1.48-1.414 3.08-1.84 4.747zM32 42.613a18.782 18.782 0 0 1-2.547-5.28h5.094A18.782 18.782 0 0 1 32 42.613zm3.12-7.946h-6.24c-.12-.88-.213-1.76-.213-2.667 0-.907.093-1.8.213-2.667h6.24c.12.867.213 1.76.213 2.667 0 .907-.093 1.787-.213 2.667zm.333 7.413c.8-1.48 1.414-3.08 1.84-4.747h3.934a10.706 10.706 0 0 1-5.774 4.747zm2.36-7.413c.107-.88.187-1.76.187-2.667 0-.907-.08-1.787-.187-2.667h4.507c.213.854.347 1.747.347 2.667 0 .92-.134 1.813-.347 2.667h-4.507z"
        fill="#7B838C"
        fillRule="nonzero"
      />
      <g fill="#D2D5D8">
        <path d="M48 23.515L56.485 32 48 40.485z" />
      </g>
    </g>
  </svg>
);

export default ReadHttp;

